import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import AboutSection from './components/AboutSection';
import ComparisonSection from './components/ComparisonSection';
import UseCasesSection from './components/UseCasesSection';
import ArticlesSection from './components/ArticlesSection';
import CTASection from './components/CTASection';
import TestimonialsSection from './components/TestimonialsSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://hipobuyspreadsheet.pro';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Hipobuy Spreadsheet',
  url: SITE_URL,
  description:
    'Découvrez Hipobuy Spreadsheet, la solution moderne pour automatiser et optimiser vos feuilles de calcul. Guide complet 2026 avec tutoriels, comparaisons et astuces SEO.',
  inLanguage: 'fr-FR',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${SITE_URL}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <AboutSection />
        <ComparisonSection />
        <UseCasesSection />
        <ArticlesSection />
        <CTASection />
        <TestimonialsSection />
      </main>
      <Footer />
    </>
  );
}